import { render, staticRenderFns } from "./vertical_1.vue?vue&type=template&id=ba35b778&scoped=true&"
import script from "./vertical_1.vue?vue&type=script&lang=js&"
export * from "./vertical_1.vue?vue&type=script&lang=js&"
import style0 from "./vertical_1.vue?vue&type=style&index=0&id=ba35b778&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba35b778",
  null
  
)

export default component.exports